export const getParams = () => {
    const queryParams = new URLSearchParams(window.location.search);
    try {       
        const skuId = queryParams.get('sku_id');
        let skuName = queryParams.get('sku_name')
        let enterpriseId = queryParams.get('enterprise_id')
           let params = skuId ? {skuId} : {skuName,enterpriseId}

        params.spin = queryParams.get('spin')
        params.ext360 = queryParams.get('ext360')
        params.int360 = queryParams.get('int360')
        params.type360 = queryParams.get('type360')
        params.feature_video = queryParams.get('feature_video')
        params.video_slot = queryParams.get('video_slot')
        params.catalog = queryParams.get('catalog')
        params.threed = queryParams.get('threed')
        params.mediaId = queryParams.get('mediaId')
        params.videoId = queryParams.get('videoId')
        params.demo    = queryParams.get('demo')
        params.template = queryParams.get('template')
        params.cols = queryParams.get('cols')
        params.heroImage = queryParams.get('heroImage')
        params.teamId = queryParams.get('teamId')

        return {params}
    } catch (error) {
        
    }

}